import { render, staticRenderFns } from "./EnvChip.vue?vue&type=template&id=445d71f0&"
import script from "./EnvChip.vue?vue&type=script&lang=js&"
export * from "./EnvChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports